export default __webpack_public_path__ + "static/olympicPark3-c814a8009b8f95ea72599ebe3c17f485.jpeg";